import ForgotPasswordComponent from "../Components/ForgotPasswordComponent";


const ForgotPasswordPage = () => {
    return (
        <div>
            <ForgotPasswordComponent />
        </div>
    );
};

export default ForgotPasswordPage;